import { Input, Directive } from '@angular/core';
import { IAbcComponent, StylingMode } from '../abcComponent.model';
export enum ColumnType {
  number = 'number',
  checkbox = 'checkbox',
  numberinput = 'numberinput',
  dropdownlist = 'dropdownlist',
  combobox = 'combobox',
  datetimeinput = 'datetimeinput',
  textbox = 'textbox',
  template = 'template',
  custom = 'custom',
}
export interface ICombobox extends IAbcComponent {
  placeholder?: string;
  internalId?: string;
  value?: any;
  caption?: string;
  visible?: boolean;
  disabled?: boolean;
  hoverStateEnabled?: boolean;
  isValid?: boolean;
  rtlEnabled?: boolean;
  readOnly?: boolean;
  maxHeight?: string;
  validationStatus?: ComboBoxValidationStatus;
  stylingMode?: StylingMode;
  setComboboxStyle?(style?: IComboboxStyle);
  setCustomDataAttributes?(data?: Object);
}
@Directive()
export class IComboboxStyle {
  @Input('height') height?: number | string;
  @Input('width') width?: number | string = '100%';
  @Input('disabled') disabled?: boolean;
}

export enum dropDownStyleMode {
  Outlined = 'outlined',
  Underlined = 'underlined',
  Filled = 'filled',
}

export enum ComboBoxValidationStatus {
  Valid = 'valid',
  Invalid = 'invalid',
  Pending = 'pending',
}
